import { AsyncBoundary } from '@rematter/ui-web';
import { useAtomValue } from 'jotai';

import * as locationsState from '../../../_state/locations.state';
import { ContentWithSideMenu } from '../../_shared/ContentWithSideMenu';
import { SettingsContent } from '../../_shared/SettingsContent';

import { GeneralPreferences } from './GeneralPreferences';
import { SalesModulePreferences } from './SalesModulePreferences';

export const LocationPreferences = () => {
  // const currentLocation = useAtomValue(locationsState.$currentLocation);
  const allLocations = useAtomValue(locationsState.$rawLocationList);

  return (
    <SettingsContent className="@LocationPreferences h-full">
      <AsyncBoundary
        loading={allLocations.isLoading}
        error={allLocations.error}
      >
        <ContentWithSideMenu
          menu={[
            {
              label: 'General',
              content: GeneralPreferences,
            },
            {
              label: 'Sales Module',
              content: SalesModulePreferences,
            },
          ]}
        />
      </AsyncBoundary>
    </SettingsContent>
  );
};
